import { Component, OnInit, inject } from '@angular/core';
import { AppConfig } from "app/app.config";
import { LoaderService } from "app/services/loader.service";
import { APIService } from 'app/services/api.service';
import { AuthenticationService, reRgType } from 'app/services/auth.service';
import { MenuComponent } from '../../../components/Controls/menu/menu.component';
import { PGFChartComponent } from '../../../components/NWMCharts/pgfchart.component';
import { NgClass, NgTemplateOutlet, CurrencyPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbPagination, NgbPaginationFirst, NgbPaginationPrevious, NgbPaginationNext, NgbPaginationLast } from '@ng-bootstrap/ng-bootstrap';
import { MinusSignToParens } from 'app/pipes/minus-sign-to-parens.pipe';

type sortFieldType = 'year' | 'donations' | 'grants';
type yearDataType = {
  year: string,
  donations: number,
  grants: number
};

@Component({
    templateUrl: './year-activity.component.html',
    styleUrls: [`./year-activity.component.scss`],
    imports: [MenuComponent, PGFChartComponent, NgClass, NgTemplateOutlet, FormsModule, NgbPagination, NgbPaginationFirst, NgbPaginationPrevious, NgbPaginationNext, NgbPaginationLast, MinusSignToParens, CurrencyPipe]
})

export class PgfYearActivityComponent implements OnInit {
  private config = inject(AppConfig);
  private loaderService = inject(LoaderService);
  private api = inject(APIService);
  auth = inject(AuthenticationService);

  public reRg?: reRgType;
  public page = 1;
  public pageSize: number = this.config.document.documentPageSize;
  public pageOptions: number[] = Array.from({length: 10}, (v, k) => (k + 1) * 10);
  public totalPages = 1;
  public dataLoaded = false;

  public sortField: sortFieldType = 'year';
  public sortDir = 1;

  public dataList: yearDataType[] = [];
  public pagedData: yearDataType[] = [];

  public years:string[] = [];
  public yearGrants: number[] = [];
  public yearDonations: number[] = [];
  public firstYear = 2000;
  public minYears = 5;

  ngOnInit() {
    this.dataLoaded = false;
    this.loaderService.display(true, 'YearActivity');

    this.reRg = this.auth.getCurrentReRg()!;

    this.api.getPgfActivityByReRgId(this.reRg!.ReRgId).subscribe({
      next: res => {
        const year = (new Date()).getFullYear();
        const maxLength = year-this.firstYear+1;
        this.loaderService.display(false, 'YearActivity');

        this.yearGrants = Array.from({length:maxLength},()=>0);
        this.yearDonations = Array.from({length:maxLength},()=>0);
        this.years = Array.from({length:maxLength},(v,k)=>''+(this.firstYear+k));

        let minYear = year;
        res.forEach(f=>{
          const y = +f.ActivityDate.split('-')[0];
          if (y<minYear) minYear = y;
          const index = y - this.firstYear;
          if (index<0 || index>year) return;
          if (f.ActivityType == 'Grant') {
            this.yearGrants[index] += f.AmountCAD;
          } else {
            this.yearDonations[index] += f.AmountCAD;
          }
        })
        let minIndex = minYear - this.firstYear;
        if (maxLength - minIndex < this.minYears) {
          /* show at least 'minYears' number of data points 
             even if there were no grants - only because 
             the chart is wide and it doesn't look good if it's only 1 or 2 bars
          */
          minIndex = maxLength - this.minYears;
        }
        if (minIndex>0) {
          this.yearGrants = this.yearGrants.slice(minIndex);
          this.yearDonations = this.yearDonations.slice(minIndex);
          this.years = this.years.slice(minIndex);
        }
        this.dataList = [];
        this.years.forEach((y,i)=>{
          this.dataList.push({
            year: y,
            donations: this.yearDonations[i],
            grants: this.yearGrants[i]
          });
        })

        this.sortData();
        this.dataLoaded = true;
      },
      error: () => this.loaderService.display(false, 'YearActivity')
    });
  }

  toggleSort(field: sortFieldType = 'year') {
    if (this.sortField == field) {
      this.sortDir = 0-this.sortDir;
    } else {
      this.sortField = field;
      this.sortDir = 1;
    }
    this.sortData();
  }

  sortData() {
    this.dataList.sort((a,b)=>
      (a[this.sortField] || '') > (b[this.sortField] || '') ? 0-this.sortDir :
      (a[this.sortField] || '') < (b[this.sortField] || '') ? this.sortDir :
      a['year'].localeCompare(b['year'])
    )
    this.setPage(1);
  }

  setPage(page: null | number = null) {
    if (page) this.page = page > 0 ? +page : 1;
    const l = this.dataList.length;
    const p = this.pageSize>0 ? +this.pageSize : l;
    if (p<l) {
      this.totalPages = p ? Math.ceil(l / p) : 1;
      if (this.totalPages < this.page) this.page = this.totalPages;
      const s = (this.page-1) * p;
      const e = s+p > l ? l : s+p;
      this.pagedData = this.dataList.slice(s, e);
    } else {
      this.totalPages = 1;
      this.pagedData = this.dataList;
    }
  }
}